import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './GuidanceAddress-hashed.scss';
import templateStr from 'text!./GuidanceAddress.html';

export default [function () {
    function isIncompleteButNotEmpty(address) {
        if (address !== '' && _.isEmpty(address.value)) {
            return false;
        }
        return !address.aspects.subtreeValid;
    }

    return {
        restrict: 'E',
        scope: {
            address: '=',
            continueToNextPanel: '&',
            isActive: '&',
            isPanelValid: '&',
            transitionFn: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', 'TranslateService', 'guidance.GuidanceService', 'LocaleService', 'addressSettings', 'AddressUtil', function ($scope, TranslateService, GuidanceService, LocaleService, addressSettings, AddressUtil) {
            $scope.isInManualEntryMode = false;
            $scope.msOfInactivityBeforeSearching = addressSettings.msOfInactivityBeforeSearching;

            $scope.switchToManualEntryMode = function () {
                var address = $scope.address;

                if (!address.value || _.isEmpty(address.value)) {
                    var localeCountryCode = LocaleService.getCountry().code;
                    address.value = {
                        country: localeCountryCode
                    };
                }
                $scope.isInManualEntryMode = true;
            };

            $scope.switchToSearch = function () {
                $scope.isInManualEntryMode = false;
            };

            if (isIncompleteButNotEmpty($scope.address)) {
                $scope.switchToManualEntryMode();
            }

            $scope.addressLookup = {
                getMatches: function getMatches(userInput) {
                    return GuidanceService.findAddress(userInput);
                },
                toString: function toString(address) {
                    if (_.isEmpty(address)) {
                        return '';
                    }
                    return AddressUtil.format(address);
                }
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/Address/GuidanceAddress.js
// module id = 958
// module chunks = 0